import { useState } from "react";
import { MenuItems } from "../types/types";

type Props = {
    product: MenuItems;
};

export const Products = ({ product }: Props) => {
    const [price, setPrice] = useState(product.itemPrice);

    const getPrice = (action: string) => {
        if (action === "minus" && price === product.itemPrice) {
            return;
        }
        return action === "minus"
            ? setPrice(price - product.itemPrice)
            : setPrice(price + product.itemPrice);
    };

    return (
        <div key={product.itemCode} className="card">
            <img
                className="card-img"
                src={`https://smartapp.acs-cis.ru/assets/img/Menu/${product.url}`}
                alt={product.itemName}
            />
            <div className="card-body">
                <div>
                    <p className="card-name">{product.itemName}</p>
                    <p className="card-desc">{product.itemDescription}</p>
                    <p className="card-width">{product.itemWeight}гр</p>
                </div>
                <div className="bag-pannel">
                    <div className="pannel minus" onClick={() => getPrice("minus")}>
                        -
                    </div>
                    <div className="price">{price}&#8381;</div>
                    <div className="pannel plus" onClick={() => getPrice("plus")}>
                        +
                    </div>
                </div>
            </div>
        </div>
    );
};
